import ActionHelper from '@wetransfer/transfer/modules/redux-actions';

export const actions = ActionHelper.types([
  'ROUTE_SET',
  'ROUTE_SET_FORMSTATE',
  'ROUTE_SET_NEXT_ACTION',
  'ROUTE_SET_TYPE_PANEL',
]);

export default ActionHelper.generate({
  setRoute: [actions.ROUTE_SET, 'route'],
  setFormState: [actions.ROUTE_SET_FORMSTATE, 'formState'],
  setNextAction: [actions.ROUTE_SET_NEXT_ACTION, 'routeAction'],
  setTypePanel: [actions.ROUTE_SET_TYPE_PANEL, 'panelType'],
});
